import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Container from './AdoptOnSide.container';
import AdoptOnSide from './AdoptOnSide';
import AdoptableForSale from '../../../exclusives/presets/AdoptableForSale';
export default withFeatureBranch({
    adoptables_resale: AdoptableForSale
})(Container(AdoptOnSide));
